<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.CREATE') }} {{ $t('FILES.ITEM') }}</span
      >
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
          >{{ e[0] }}</v-alert
        >
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="document.title"
          :counter="255"
          :rules="rules.requiredTextLine"
          :label="`${$t('ITEM.TITLE')} *`"
        ></v-text-field>

        <v-select
          v-model="document.type_id"
          :loading="!!!types.length"
          :items="types"
          item-text="text"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('ITEM.TYPE')} *`"
        ></v-select>

        <div class="container">
          <div class="large-12 medium-12 small-12 cell">
            <autoupload-file-input
              :label="$t('DOCUMENTS.FILE')"
              :url="`uploads/documents`"
              destroyed
              @input="document.upload_id = $event"
            ></autoupload-file-input>
          </div>
        </div>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>

            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
              >{{ $t('BUTTON.SAVE') }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import AutouploadFileInput from '@/modules/_global/_components/AutouploadFileInput';
import {
  requiredTextLine,
  requiredSelectNotArray
} from '@/modules/_global/variables/rules.js';
import { mapActions } from 'vuex';

export default {
  name: 'DocumentsCreate',

  components: {
    AutouploadFileInput
  },

  props: {
    person: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    testInput: undefined,
    document: {
      type_id: undefined,
      upload_id: undefined
    },
    types: [],
    error: null,
    valid: true,
    rules: {
      requiredTextLine,
      requiredSelectNotArray
    }
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    let getTypes = 'document/retrieveTypes';

    if (this.person) getTypes = 'document/retrieveTypesAdministrative';

    this.$store.dispatch(getTypes).then(({ data }) => {
      data.forEach(type => {
        type.text = this.$t('DOCUMENTS.' + type.title.toUpperCase());
      });
      this.types = data;
    });
  },

  methods: {
    ...mapActions('document', ['storeDocument', 'addDocumentForPerson']),
    validate() {
      if (this.$refs.form.validate()) {
        this.storeDocument(this.document)
          .then(response => {
            if (this.person) {
              return this.addDocumentForPerson({
                person_id: this.person.id,
                document_id: response.data.id
              }).then(() => response);
            } else {
              return response;
            }
          })
          .then(({ data }) => {
            this.$emit('success', data);
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    }
  }
};
</script>
